import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

// Demo credentials sourced from .env (VITE_DEMO_USERNAME / VITE_DEMO_PASSWORD).
// NOTE: this is a client-side demo gate, not real authentication —
// Vite inlines these into the bundle at build time, so they're visible to
// anyone who inspects the shipped JS. Use only as friction for internal demos.
const DEMO_USERNAME = import.meta.env.VITE_DEMO_USERNAME ?? '';
const DEMO_PASSWORD = import.meta.env.VITE_DEMO_PASSWORD ?? '';

if (!DEMO_USERNAME || !DEMO_PASSWORD) {
  console.warn(
    '[auth] VITE_DEMO_USERNAME and/or VITE_DEMO_PASSWORD not set — sign-in will be disabled.',
  );
}

type AuthState = {
  authenticated: boolean;
  signIn: (username: string, password: string) => boolean;
  signOut: () => void;
};

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      authenticated: false,
      signIn: (username, password) => {
        if (!DEMO_USERNAME || !DEMO_PASSWORD) return false;
        const ok = username.trim() === DEMO_USERNAME && password === DEMO_PASSWORD;
        if (ok) set({ authenticated: true });
        return ok;
      },
      signOut: () => set({ authenticated: false }),
    }),
    {
      name: 'rcmc-auth',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (s) => ({ authenticated: s.authenticated }),
    },
  ),
);
